import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { Role } from 'src/app/common/enums/role.enum';
import { QrScannerService } from 'src/app/common/services/qr-scanner/qr-scanner.service';
import { UserProfileService } from 'src/app/common/services/user-profile/user-profile.service';
import { ProfileModel } from 'src/app/swagger';

@Component({
    selector: 'app-tabs',
    templateUrl: './tabs.component.html',
    styleUrls: ['./tabs.component.scss'],
    standalone: false
})
export class TabsComponent implements OnInit {

  public userProfile: ProfileModel;
  public isAdmin: boolean = false;
  public isRestoAdmin: boolean = false;
  public isCustomer: boolean = false;
  public isTvScreenView: boolean = false;

  constructor(
    private userProfileService: UserProfileService,
    private qrScannerService: QrScannerService,
    private router: Router
  ) {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd))
    .subscribe(() => {
      this.checkIfTvScreenView();
    });
   }

  public ngOnInit() {
    this.init();
  }

  private checkIfTvScreenView(): void {
    const currentPath = this.router.url.split('?')[0]; // extract path without query params
    this.isTvScreenView = currentPath === '/resto-admin/live-kitchen';
  }

  public onScanClick() {
    this.qrScannerService.notify({ action: 'open-scanner' });
  }

  public init() {
    this.setUserProfile();
  }

  private setUserProfile() {
    this.userProfileService.getUserProfile().subscribe({
      next: (userProfile: ProfileModel) => {
        if(userProfile){
          this.userProfile = userProfile;
          this.isRestoAdmin = userProfile.roles.includes(Role.RESTO_ADMINS);
          this.isCustomer = userProfile.roles.includes(Role.USERS);
        }
      },
      error:(err) => {
        console.error('Unable to Get UserProfile ',err);
      }
    });
  }

}
